module.exports = __webpack_public_path__ + "img/spider-chart-sample.7dd58705.svg";